/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Notifications_Task_Assigned_TitleInputs */

const en_notifications_task_assigned_title = /** @type {(inputs: Notifications_Task_Assigned_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Task assigned: ${i?.task}`)
};

const pt_br2_notifications_task_assigned_title = /** @type {(inputs: Notifications_Task_Assigned_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atividade atribuída: ${i?.task}`)
};

/**
* | output |
* | --- |
* | "Task assigned: {task}" |
*
* @param {Notifications_Task_Assigned_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_assigned_title = /** @type {((inputs: Notifications_Task_Assigned_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Assigned_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_assigned_title(inputs)
	return pt_br2_notifications_task_assigned_title(inputs)
});